




































































import { Notif } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import { doInterval, route_replace, time_format } from "@/shared/utils";
import { DataTableHeader } from "vuetify";
import { visitorType } from "@/api/api.types";
import { get_visitor } from "@/api";
import PhotoAvatar from "@/components/PhotoAvatar.vue";
import DatePicker from "@/components/DatePicker.vue";

@Component({ name: "visitor-index", components: { PhotoAvatar, DatePicker } })
export default class VisitorIndex extends Vue {
  /* Variables */

  time_format = time_format;

  tableData = [] as visitorType["data"]["_embedded"]["visitor"];

  tableFilter = {
    search_name: this.$route.query.search_name || null,
    start_date: this.$route.query.start_date || null,
    end_date: this.$route.query.end_date || null,
  };

  date = this.$route.query.start_date
    ? [this.$route.query.start_date, this.$route.query.end_date]
    : [];

  loading = false;

  page = {
    page_count: 0,
    page_size: 0,
    page: 1,
  };

  edit = "";

  /* Computed */

  public get TableHeader(): DataTableHeader[] {
    return [
      { text: "Name", value: "firstName" },
      { text: "Type", value: "type" },
      { text: "Photo", value: "photo" },
      { text: "Phone", value: "phone" },
      { text: "IC Number", value: "icNumber" },
      { text: "Created", value: "createdAt" },
      { text: "", value: "actions", sortable: false },
    ];
  }

  /* Methods */

  async fetchData(toPage = this.page.page): Promise<void> {
    if (toPage == 0) toPage = 1;
    this.loading = true;
    try {
      const resp = await get_visitor({ ...this.tableFilter, page: toPage });
      const { page, page_count, page_size } = resp.data;
      this.tableData = resp.data._embedded.visitor;
      this.page = { page, page_count, page_size };
      route_replace(this.$route.path, { ...this.tableFilter, page: toPage });
    } catch (error) {
      Notif.notif_api_error(error);
    } finally {
      this.loading = false;
    }
  }

  /* Life-cycle Methods */

  mounted(): void {
    this.fetchData();
    const title = this.$route.name;
    doInterval(this.fetchData, title);
  }
  @Watch("page.page")
  onPageChange(now: number): void {
    if (now) this.fetchData();
  }
}
